import { cx } from 'class-variance-authority';

export default function FormRow({ children, className }: { children: React.ReactNode; className?: string }) {
    return <div className={cx('tw-flex tw-items-start tw-gap-2 *:tw-w-full *:tw-flex-1', className)}>{children}</div>;
}
